module.exports = __webpack_public_path__ + "img/njnja.c5e2eb70.png";